import { render, staticRenderFns } from "./AthleteOnboarding.vue?vue&type=template&id=19c1a420&"
import script from "./AthleteOnboarding.vue?vue&type=script&lang=ts&"
export * from "./AthleteOnboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports